import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MonedaSelect } from 'sharedComponents/select'

import { KeyEventUtil } from 'utils'

const MonedaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('date-fechaEmision', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-moneda' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='moneda'>
          {({ field }) => (
            <MonedaSelect {...field} id='select-moneda' disabled={fIsSubmitting} isInvalid={iTouched && iError} onKeyDown={onKeyDown} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
